var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3197 27.984V25.3187C25.3197 23.905 24.7581 22.5492 23.7584 21.5495C22.7588 20.5499 21.4029 19.9883 19.9892 19.9883H11.9935C10.5798 19.9883 9.22399 20.5499 8.22434 21.5495C7.22469 22.5492 6.66309 23.905 6.66309 25.3187V27.984",
    stroke: "#0A0A0A",
    strokeOpacity: 0.4,
    strokeWidth: 2.66523,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9916 14.657C18.9355 14.657 21.322 12.2705 21.322 9.32654C21.322 6.38262 18.9355 3.99609 15.9916 3.99609C13.0477 3.99609 10.6611 6.38262 10.6611 9.32654C10.6611 12.2705 13.0477 14.657 15.9916 14.657Z",
    stroke: "#0A0A0A",
    strokeOpacity: 0.4,
    strokeWidth: 2.66523,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPerson);
export default __webpack_public_path__ + "static/media/Gray_person.f88987737ca12bc53cf8904ac406409e.svg";
export { ForwardRef as ReactComponent };